module.exports = __webpack_public_path__ + "static/component-background-75efc8868f0f22315d1b2fdcd514e311.png";